var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.brandWarning)?_c('div',{staticClass:"brandWarning"},[_c('span',[_vm._v("Please select a brand")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }